/*
 dateHelper

 This class provides date helper functions

 */

import _ from 'lodash';
import moment from 'moment';

var DateHelper = (function () {

  function dateHelper() {}

  //Returns a date from a string in the format of YYYY-MM-DD
  dateHelper.prototype.getDateFromString = function (dateString) {

    if (_.isNullOrUndefined(dateString)) {
      return undefined;
    }

    var result = moment(dateString, "YYYY-MM-DD");
    return result.toDate();
  }

  //Returns a date from a string in the format of YYYY-MM-DD
  dateHelper.prototype.getShortDateString = function (dateObj) {

    if (_.isNullOrUndefined(dateObj)) {
      return undefined;
    }

    return moment(dateObj).format('MM/DD/YYYY');
  }

  //Returns a report start date based on the currently stored date range and interval.
  dateHelper.prototype.getDateRangeStartDate = function (interval, dateRange) {

    var dateAmount = getCurrentDateRangeUnit(dateRange); // 0, 3, 6, 12 (i.e. current, last 3, last 6, last 12)
    var dateInterval = interval.replace("period", "year").replace("fiscalyear", "year"); // day, week, month, year, period, fiscalyear, custom

    var startDate;
    if (dateInterval == "custom") {
      var toIndex = dateRange.toLowerCase().indexOf("-to-");
      if (toIndex > -1) {
        startDate = moment(dateRange.substring(0, toIndex));
      }
    }
    else {
      startDate = moment().startOf(dateInterval).subtract(dateAmount, dateInterval);
    }

    //TODO: remove this when we get more current data
    if (dateInterval != "custom")
      startDate.subtract(4, "year");

    return startDate.toDate();
  }

  //Returns a report end date based on the currently stored date range and interval.
  dateHelper.prototype.getDateRangeEndDate = function (interval, dateRange) {

    var dateAmount = getCurrentDateRangeUnit(dateRange); // 0, 3, 6, 12 (i.e. current, last 3, last 6, last 12)
    var dateInterval = interval.replace("period", "year").replace("fiscalyear", "year"); // day, week, month, year, period, fiscalyear, custom

    var endDate;
    if (dateInterval == "custom") {
      var toIndex = dateRange.toLowerCase().indexOf("-to-");
      if (toIndex > -1) {
        endDate = moment(dateRange.substring(toIndex + 4));
      }
    }
    else {
      var startDate = moment().startOf(dateInterval).subtract(dateAmount, dateInterval);
      endDate = startDate.add(dateAmount == 0 ? 1 : dateAmount, dateInterval).subtract(1, "day");
    }

    //TODO: remove this when we get more current data
    if (dateInterval != "custom")
      endDate.subtract(4, "year");

    return endDate.toDate();
  }

  //Helper function to return date range units.
  var getCurrentDateRangeUnit = function (dateRange) {
    switch (dateRange) {
      case "current":
        return 0;
        break;
      case "last3":
        return 3;
        break;
      case "last6":
        return 6;
        break;
      case "last12":
        return 12;
        break;
      default:
        return 0;
    }
  }

  return dateHelper;
})();

export const dateHelper = new DateHelper();